import React from 'react';

const BlankPage = () => (
  <div>

  </div>
);

export default BlankPage;
